import { useComponentTranslation } from '@tebuto/functions/translation.components'
import ConfirmationDialogue from '@tebuto/modals/ConfirmationDialogue'
import MediumText from '@tebuto/typography/MediumText'
import { useContext } from 'react'
import { BookingCalendarContext } from './context'

interface EventNotAvailableDialogProps {
    refresh: (() => void) | (() => Promise<void>)
}

export default function EventNotAvailableDialog({ refresh }: EventNotAvailableDialogProps) {
    const { t } = useComponentTranslation()
    const { isEventNotAvailableDialogOpen, setIsEventNotAvailableDialogOpen } = useContext(BookingCalendarContext)
    return (
        <ConfirmationDialogue
            open={isEventNotAvailableDialogOpen}
            setOpen={setIsEventNotAvailableDialogOpen}
            title={t('booking.bookingCalendar.bookingNotAvailableDialog.title')}
            submitButtonText={t('booking.bookingCalendar.bookingNotAvailableDialog.refresh')}
            onSubmit={refresh}
        >
            <MediumText>{t('booking.bookingCalendar.bookingNotAvailableDialog.message')}</MediumText>
        </ConfirmationDialogue>
    )
}
